<template>
  <a-card :bordered="false" :actionon="actionon">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="业务类型名">
              <a-input v-model="queryParam.name" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="节点类型">
              <a-select
                showSearch
                :filterOption="filterOption"
                v-model="queryParam.nodeTypeId"
                default-value="0"
                placeholder="请选择"
              >
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in nodeTypeSelect"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{  }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item
          label="业务类型名"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
          :validate-status="mdl.name == '' ? 'error' : ''"
          :help="mdl.name == '' ? '请输入业务类型名' : ''"
        >
          <a-input v-model="mdl.name" @change="changeNodeType($event)" placeholder="请输入业务类型名" />
        </a-form-item>

        <a-form-item
          label="节点类型"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
          :validate-status="mdl.nodeTypeId == '' ? 'error' : ''"
          :help="mdl.nodeTypeId == '' ? '请选择节点类型' : ''"
        >
          <a-select
            showSearch
            :filterOption="filterOption"
            @change="changeNodeType($event, 1)"
            v-model="mdl.nodeTypeId"
            placeholder="请选择节点类型"
          >
            <a-select-option value>全选</a-select-option>
            <a-select-option
              v-for="(item, index) in nodeTypeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="业务节点" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <div :style="{ borderBottom: '1px solid #E9E9E9' }">
            <a-checkbox
              :indeterminate="indeterminate"
              @change="onCheckAllChange"
              :checked="checkAll"
            >全选</a-checkbox>
          </div>
          <a-checkbox-group :options="nodesModel" v-model="checkedList" @change="onChange" />
        </a-form-item>

        <a-form-item label="是否有订单" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-radio-group v-model="mdl.hasOrder" defaultValue="0">
            <a-radio-button
              v-for="(item, index) in yesOrNoSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { businessTypePage, businessTypeUpdate, businessTypeSave, businessTypeDelete } from '@/api/basic'
import {
  menuPage,
  menuUpdate,
  menuSave,
  menuDelete,
  menuList,
  codePage,
  codeTypeList,
  codeUpdate,
  codeSave,
  codeDelete
} from '@/api/sys'
import { getTextByTypeAndValue } from '../../utils/util'

export default {
  name: 'BusinessType',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},

      // 强制渲染参数
      actionon: 1,

      // 节点模板集合
      checkedList: [],
      indeterminate: false,
      checkAll: false,
      nodesModel: [],

      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '8%'
        },
        {
          title: '业务类型名',
          dataIndex: 'name',
          width: '20%'
        },
        {
          title: '节点类型',
          dataIndex: 'nodeTypeName',
          width: '20%'
        },
        {
          title: '节点',
          dataIndex: 'processNodeIds',
          width: '40%',
          customRender: (value, row, index) => {
            let nodeids = value.split(',')
            let nodeStr = ''
            for (let i = 0; i < nodeids.length; i++) {
              if (nodeids[i]) {
                nodeStr += getTextByTypeAndValue(this.$store.getters.codeList, row.nodeTypeId, nodeids[i])
                if (i < nodeids.length - 1) {
                  nodeStr += ' => '
                }
              }
            }
            return nodeStr
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],

      // 节点类型下拉
      nodeTypeSelect: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return businessTypePage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true,
      yesOrNoSelect: null
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
  },
  methods: {
    loadSelect() {
      // 拉取下拉列表数据
      this.nodeTypeSelect = this.$store.getters.codeList.basic_business_type_node_type
      this.yesOrNoSelect = this.$store.getters.codeList.sys_yes_or_no
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      // 清空旧的数组
      this.nodesModel = []
      this.checkedList = []
      // 初始化节点模板
      const arr = this.$store.getters.codeList[this.mdl.nodeTypeId]
      function compare(property){
        return function(a, b){
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        }
      }
      arr.sort(compare('value'))
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i]
        this.nodesModel.push({ label: element.name, value: element.value })
      }
      // 初始化选中项
      let str = this.mdl.processNodeIds
      if (str) {
        this.checkedList = str.split(',')
      }
      this.indeterminate = !!this.checkedList.length && this.checkedList.length < this.nodesModel.length
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      // 初始化相关数据容器
      this.indeterminate = false
      this.nodesModel = []
      this.checkedList = []
      this.mdl = {}
      this.mdl['hasOrder'] = '0'
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 节点处理
          this.confirmLoading = true
          const arr = this.checkedList
		  arr.sort()
          let str = ''
          for (let i = 0; i < arr.length; i++) {
            const nodeModelNalue = this.nodesModel.map(v => {
              return v.value
            })
            if (nodeModelNalue.indexOf(arr[i]) >= 0) {
              str += arr[i]
              if (i < arr.length - 1) {
                str += ','
              }
            }
          }
          this.mdl.processNodeIds = str

          // 输入验证
          if (!this.mdl.name) {
            this.mdl.name = ''
            this.actionon++
            return
          }
          if (!this.mdl.nodeTypeId) {
            this.mdl.nodeTypeId = ''
            this.actionon++
            return
          }

          if (this.mdl.id !== undefined) {
            businessTypeUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            businessTypeSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return businessTypeDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    changeNodeType(e, flag) {
      this.actionon++
      // 更改业务类型时更新节点模板
      if (flag == 1) {
        // 清空旧的集合
        this.nodesModel = []
        // 根据业务类型装在新节点模板
        const arr = this.$store.getters.codeList[e]
        for (let i = 0; i < arr.length; i++) {
          const element = arr[i]
          this.nodesModel.push({ label: element.name, value: element.value })
        }
      }
    },
    onChange(checkedList) {
      // 更改选项时动态更新全选按钮
      this.indeterminate = !!checkedList.length && checkedList.length < this.nodesModel.length
      this.checkAll = checkedList.length === this.nodesModel.length
    },
    onCheckAllChange(e) {
      // 更改全选按钮时更改选项
      if (e.target.checked) {
        this.checkedList = this.nodesModel.map(v => {
          return v.value
        })
      } else {
        this.checkedList = []
      }
      this.indeterminate = false
      this.checkAll = e.target.checked
    }
  }
}
</script>
